import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskProcessingRPage = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskProcessingRPage;

